export default "__VITE_ASSET__BrVXELCG__"